// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609211640/js/" + chunkId + "." + {"44":"90bfa993","225":"d65ae287","481":"e4f3c154","486":"bfd39c64","770":"df1232da"}[chunkId] + ".0.05392091926718501.chunk.js";
};